<template>
  <div style="width:100%;float:left;">

    <CRow v-if="$store.state.user" class="p-0">
      <CCol class="p-0" sm="12">
        <CCard class="mb-0 p-3">
          <CCardBody style="text-align:center;padding:1px !important;">
            <div class="col-sm-12 col-md-12 text-center">
                <label class="cust-name" style="color:grey;">Customer Showing</label>
                <div style="width:100%;" class="cust-name text-center mt-3" v-if="customer_selected">
                  {{ customer_selected.customer_name }} - {{ customer_selected.customer_number }}
                  <CButton size="sm" color="outline-danger" @click="customer_selected = '', customerSearch = '', customerModal = true">Change</CButton>
                </div>
              <div style="width:100%;" class="text-center" v-else-if="!customerModal">
                <CButton size="sm" color="outline-danger" @click="customer_selected = '', customerSearch = '', customerModal = true">Choose Customer</CButton>
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-6 float-left text-center" v-if="customer_selected">
              <label style="color:grey;">Report Selected</label>
              <v-select style="width:300px;margin-left:auto;margin-right:auto;" v-model="reportSelected" placeholder="Select Report" :options="reportOptions"></v-select>
            </div> -->
            <div class="col-12 float-left text-center mt-4">
              <CButton size="sm" color="info" @click="refresh()">Refresh</CButton>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <div class="tabs-wrapper mt-3">

      <h1 v-if="customer_selected">{{ customer_selected.customer_name }} - {{ customer_selected.customer_number }}</h1>

    <!-- Tabs -->
    <ul class="nav-tabs">
      <li :class="{ active: activeTab === 'Customer Summary' }" @click="activeTab = 'Customer Summary'">Customer Summary</li>
      
      <!-- <li :class="{ active: activeTab === 'Customer 360' }" @click="activeTab = 'Customer 360'">Customer 360</li> -->
      <li :class="{ active: activeTab === 'all-orders' }" @click="activeTab = 'all-orders'" style="background-color: #f0d0a0;">Orders All</li>
      <li :class="{ active: activeTab === 'prebooks' }" @click="activeTab = 'prebooks'" style="background-color:  #FFEBCD;">Prebooks</li>
      <li disabled :class="{ active: activeTab === 'events' }" @click="activeTab = 'events'" style="background-color:  #FFEBCD;">Events</li>
      <li :class="{ active: activeTab === 'fillins' }" @click="activeTab = 'fillins'" style="background-color:   #FFEBCD;">Fill-ins</li>

      <li :class="{ active: activeTab === 'Customer Invoices' }" @click="activeTab = 'Customer Invoices'">Invoices</li>
      <li :class="{ active: activeTab === 'Inventory' }" @click="activeTab = 'Inventory'">Inventory</li>
      <!-- <li :class="{ active: activeTab === 'Top Sellers' }" @click="activeTab = 'Top Sellers'">Top Sellers</li> -->
    </ul>

  </div>

    <CRow v-if="$store.state.user && !customerLoading && customer_selected && !loading" style="padding-top:15px;">
      <customer-summary v-if="activeTab === 'Customer Summary'" @loaded="loadingChanged" :customer_selected="customer_selected" :customerOptions="customerOptions"></customer-summary>
      <order-history-table v-if="['all-orders','prebooks','events','fillins'].includes(activeTab)" @loaded="loadingChanged" :customer_selected="customer_selected" :activeTab="activeTab"></order-history-table>
      <!-- <customer-orders v-if="activeTab === 'all-orders'" @loaded="loadingChanged" :customer_selected="customer_selected" :fromDash="false"></customer-orders> -->
      <customer-invoices v-if="activeTab === 'Customer Invoices'" @loaded="loadingChanged" :customer_selected="customer_selected"></customer-invoices>
      <incoming-inventory v-if="activeTab === 'Inventory'" @loaded="loadingChanged" :customer="customer_selected" :fromDash="true"></incoming-inventory>
      <!-- <customer-top-items v-if="activeTab === 'Top Sellers'" @loaded="loadingChanged" :customer_selected="customer_selected"></customer-top-items> -->
      
      <!-- <customer-360 v-if="activeTab === 'Customer 360'" @loaded="loadingChanged" :customer_selected="customer_selected"></customer-360> -->
      <!-- <small-loader v-show="loading" /> -->
    </CRow>
    <small-loader v-if="customerLoading" />

    <CModal
        title="Select Customer"
        :show.sync="customerModal"
        :no-close-on-backdrop="true"
        @close="closedModal"
        color="success"
        size="xl"
      >
      <div style="width:100%;float:left;" v-if="customerModal">
        <div class="col-12 float-left">Division: Imperial Headwear</div>
        <div class="col-12 float-left searchWrapper mt-2">
          <input type="text"
            class="form-control searchBox"
            placeholder="Search Customer By Number or Name"
            @keyup.enter="searchCustomer()"
            v-model="customerSearch"
            :disabled="customerLoading" />
          <CButton size="sm" class="searchButton" color="success" @click="searchCustomer()" :disabled="customerLoading">Search Customer</CButton>
        </div>
        <div class="col-12 float-left" v-if="customerOptions && customerOptions.length > 1">
          <table class="table">
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Customer Number</th>
              </tr>
            </thead>
            <tbody>
              <tr @click="customer_selected = val, customerModal = false" v-for="val in customerOptions">
                <td>{{ val.customer_name }}</td>
                <td>{{ val.customer_number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 float-left text-center mt-2" v-if="customerOptions && customerOptions.length === 0">
          Sorry, it doesn't look like there is a customer found with what you searched. If you believe there should be, please contact your CSR and let them know. Thanks!
        </div>
        <small-loader v-if="customerLoading"></small-loader>
      </div>
      <template #footer>
        <div style="width:100%;float:left;text-align:center;"> <CButton size="sm" color="danger" @click="closedModal()" >Close</CButton> </div>
      </template>
    </CModal>
  </div>
</template>
<script>
import CustomerOrders from './../orders/customer_orders'
import OrderDisplay from './../orders/order_display.vue'
import IncomingInventory from './../components/incoming_inventory'
import CustomerSummary from './customer_summary'
import CustomerInvoices from './customer_invoices'
import CustomerTopItems from './customer_top_items'
import OrderHistoryTable from './order_history_table'
import Customer360 from './customer_360'
// import DatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css'


var methods = {}

methods.loadingChanged = function (e) {
  this.loading = false
}

methods.closedModal = function() {
  console.log('closed modal')
  this.customerModal = false
  this.$forceUpdate()
}

methods.searchCustomer = function () {
  this.customerLoading = true
  this.customerOptions = null
  const postData = {
    search: this.customerSearch
  }
  axios.post(this.$apiAdress + '/api/searchCustomers?token='+localStorage.getItem('api_token'), postData).then(response => {
    console.log('searching customer')
    console.log(response)
    this.customerOptions = response.data
    if (this.customerOptions.length === 1) {
      this.customer_selected = this.customerOptions[0]
      this.customerModal = false
    }
    this.customerLoading = false
  })
}

methods.refresh = function () {
  this.loading = true
  var that = this
  setTimeout(function () {
    that.loading = false
  }, 500)
}

methods.checkCustomer = function () {
  // if (this.fromDash) {
    // if (localStorage.getItem('customer_portal_selected')) {
    //   this.customer_selected = JSON.parse(localStorage.getItem('customer_portal_selected'))
    // }
  // }
  return
}


export default {
  // ===Component name
  name: "CustomerPortal",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {
    IncomingInventory,
    CustomerSummary,
    CustomerInvoices,
    CustomerTopItems,
    CustomerOrders,
    OrderDisplay,
    Customer360,
    OrderHistoryTable
  },
  // ====component Data properties
  data(){
      return{
        customerOptions: null,
        customer_selected: '',
        customerLoading: false,
        reportSelected: 'Customer Summary',
        loading: false,
        reportOptions: ['Customer Invoices', 'Customer 360', 'Customer Summary', 'Inventory', 'Orders', 'Top Sellers'],
        customerModal: true,
        customerSearch: '',
        activeTab: 'Customer Summary',
      }
  },
  watch: {
    customerModal: function (newVal, oldVal) {
      // if (!this.customer_selected) {
      //   this.customerModal = true
      // }
    },
    activeTab: function (newVal, oldVal) {
      this.tabsLoading = true
      var that = this
      setTimeout(function () {
        that.tabsLoading = false
      }, 500)
    },
    customer_selected: function (newVal, oldVal) {
      if (newVal) {
        console.log('customer selected:', newVal.customer_number)
      }
    }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.checkCustomer()
    // if (localStorage.getItem('customer_portal_selected')) {
    //   this.customer_selected = JSON.parse(localStorage.getItem('customer_portal_selected'))
    // }
    // this.getCustomerOrders()
  },
  // ===Computed properties for the component
  computed: {
      
  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>

.cust-name {
  font-size: 18px;
}

.tabs-wrapper {
  font-family: sans-serif;
}

.nav-tabs {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding-left: 0;
  margin-bottom: 10px;
}

.nav-tabs li {
  font-size: 16px;
  list-style: none;
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-bottom: none;
  background-color: #f7f7f7;
  margin-right: 5px;
}

.nav-tabs li.active {
  background-color: white;
  border-top: 3px solid black;
  font-weight: bold;
}

.orders-tab {
  background-color:blanchedalmond;
}

</style>